import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';
import { getViewIndex } from './commonSelectors';

export const getlegend = (state: AppState) => state.legend;

export const getIsEditLegendVisible = createSelector(
  [getlegend, getViewIndex],
  (legend, index) => Boolean(legend.isEditLegendVisible[index])
);
